import { environment } from '@10000/react'

const request = (path, body, region = 'AP') => {
  const base = path.startsWith('/') ? '' : 'http' + environment.hostUrl(region).substring(2)
  const url = `${base}${path}`

  return fetch(url, {
    method: body ? 'POST' : 'GET',
    body: JSON.stringify(body),
    headers: { 'Content-Type': 'application/json' }
  })
    .then(response => response.json())
    .then(result => {
      if(!result.success && !result.challenge) {
        // this should be new Error(result.message) but it seems like react-forms doesn't handle Error objects... :-\
        throw result.message
      }
      return result
    })
}

const persistUser = result => {
  window.localStorage.setItem('socket.authenticatedUser', JSON.stringify(result.user))
  return result
}

export const authenticate = (username, password, session) => request('authenticate', { username, password, session }).then(persistUser)
export const signUp = (email, country, name, avatar, free) => request('signUp', { email, country, data: { name, avatar, free, country } })
export const createAccount = (email, code, region) => request('createAccount', { email, code, authenticate: true }, region).then(persistUser)
export const resendCode = email => request('resendCode', { email })
export const forgotPassword = (email, code, password) => request('forgotPassword', { email, code, password })
export const resendTemporaryPassword = (email) => request('resendTemporaryPassword', { email })
export const country = () => environment.development ? Promise.resolve({ country: 'AU' }) : request('/country')
